export default "__VITE_ASSET__DSvl0pHU__"